import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { useNavigate } from 'react-router-dom';

import postVuplexMessage from '../service/message-vuplex';
import HeroIcon from './common/hero-icon';
import queries from '../graphql/queries';

import SettingsIcon from '../icons/hero/Settings.png';
import HelpDisabledIcon from '../icons/Settings_FacLimit.png'

const SettingsHeroIcon = (props) =>
{
	const navigate = useNavigate();

	const audiomessage = "Tools/Settings/Press"; 
	const hoveraudiomessage = "Tools/Settings/HL";
	const uiDisabledResult = useQuery(queries.uiDisabled);
	const uiDisabled = uiDisabledResult.data?.uiDisabled;

	const onClickSettings = (toolbar) =>
	{
		if (toolbar)
		{
			postVuplexMessage('Request settings view', null);
		}
		else
		{
			navigate('/view/settings/general');
		}
	};

	return (
		<HeroIcon
			name="Settings"
			noBackground={props.noBackground}
			disabled={uiDisabled}
			icon={uiDisabled ? HelpDisabledIcon : SettingsIcon}
			uiAudioMessage = {audiomessage}
			uiHoverAudioMessage = {hoveraudiomessage}
			onPointerDown={() => onClickSettings(props.isToolbar)}
			hotkey="4"
			facLocked={uiDisabled}
		/>
	);
};

export default SettingsHeroIcon;
